import type { Application } from "../types";

/** Default applicants when the app loads before the API responds — empty in production. */
export const initialApplications: Application[] = [];
